if(window.location.href.indexOf('search-results') !== -1){
  document.querySelector('body').classList.add('klevu-search');
  document.querySelector('.page').classList.add('max-width-container' ,'collection--main');
  document.querySelector('.page').classList.remove('med-width-container');
}

if (!Object.entries)
Object.entries = function( obj ){
  var ownProps = Object.keys( obj ),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--)
    resArray[i] = [ownProps[i], obj[ownProps[i]]];

  return resArray;
};

var klevu_productSwatches = ('undefined' !== typeof window.colorSwatches) ? Object.entries(window.colorSwatches) : '',
  klevu_commonColorMap = [],
  klevu_commonColorMapFormatted = [],
  klevu_commonColors = {},
  klevu_filterNames = [],
  klevu_colorSelected = [],
  klevu_colorSelectedId = [],
  klevu_uc = {
      loadLayout: function () {
          var doc = document,
              searchBox,
              landingPageUrl,
              ptRsDiv,
              wrapper,
              searchIcon,
              pageBody = doc.getElementsByTagName('body')[0];

          if( 'undefined' !== typeof klevuLayoutVersion ){
              klevu_userOptions.minimumLetters = 1;
              klevu_userOptions.autoComplete = true;
              if( 'undefined' !== typeof klevu_categorySearchEnabled &&
                  klevu_categorySearchEnabled ){
                klevu_userOptions.autoCompleteFilters = 'category';
              }
              if( ( 'undefined' !== typeof klevu_cms_module_enabled &&
                  klevu_cms_module_enabled && klevu_cmsSearchEnabled ) ||
                  ( 'undefined' !== typeof klevu_shopifyStore &&
                  klevu_shopifyStore && 'undefined' !== typeof klevu_cmsEnabled && klevu_cmsEnabled ) ){
                klevu_userOptions.cmsEnabled = true;
                klevu_cmsApiKey = klevu_apiKey;
                if(klevu_userOptions.autoCompleteFilters.trim().length>0){
                  klevu_userOptions.autoCompleteFilters += ':cms';
                }else{
                  klevu_userOptions.autoCompleteFilters = "category:cms";
                }
              } else{
                klevu_userOptions.cmsEnabled = false;
                //klevu_userOptions.autoCompleteFilters = 'category';
              }
              klevu_userOptions.layoutVersion = '2.0';
              klevu_userOptions.recordsPerPage = 3;
              if( 'undefined' !== typeof klevu_productsToShowInSlimLayout ){
                klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout;
              }
              klevu_userOptions.fetchFilters = false;
              klevu_filtersEnabled = false;
              klevu_userOptions.rsPsClickBehaviour = 'redirect';
              if( 'undefined' !== typeof klevu_rsPsClickBehaviour ){
                klevu_userOptions.rsPsClickBehaviour = klevu_rsPsClickBehaviour || 'redirect';
              }
              if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showResultsData ){
                klevu_layout.renderResults = klevu_uc.showResultsData;
              }
              if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.addAutocompleteLayoutToPage ){
                klevu_layoutSetup.addLayoutToPage = klevu_uc.addAutocompleteLayoutToPage;
              }
              if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showAutocompleteProducts ){
                klevu_layout.displayProductdata = klevu_uc.showAutocompleteProducts;
              }
              if( 'undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.displayNoResultData ){
                klevu_layout.displayNoResultData = klevu_uc.displayNoResultData;
              }
              klevu_userOptions.showOnlyOriginalAndSalePrices = true;
              klevu_layoutSetup.addLayoutToPage(pageBody);

              try {
                  if(klevu_productSwatches === '') {
                      throw 'Error in getting Global Swatches. Showing Default Color Filters';
                  }
                  else {
                          // For each item in Global Swatch Area, map the common color to the base color for comparsion
                          for(var p = 0; p < klevu_productSwatches.length; p++) {
                              var baseColor = (klevu_productSwatches[p][1]['baseColor'].indexOf(',') === -1) ? klevu_productSwatches[p][1]['baseColor'] : 'multicolor',
                                  chaseColorMap,
                                  newColor = '',
                                  productColor = klevu_productSwatches[p][0],
                                  formatColor = (productColor && productColor.indexOf('/') !== -1) ? productColor.split('/') : capitalizeColors(productColor),
                                  baseColorMap;


                              baseColorMap = productColor + ':' + baseColor;

                              if( typeof formatColor !== 'string' ) {
                                  for(var c = 0; c < formatColor.length; c++) {
                                      // Capitalize Color, Replace Dashes with Spaces, add Back Slash
                                      newColor += capitalizeColors(formatColor[c].replace(/-/g, ' ')) + '/';
                                  }
                                  // Remove last backslash 
                                  chaseColorMap = newColor.slice(0, -1) + ':' + capitalizeColors(baseColor);
                              }
                              else {
                                  // Capitalize Color, Replace Dashes with Spaces
                                  chaseColorMap = capitalizeColors(formatColor.replace(/-/g, ' ')) + ':' + capitalizeColors(baseColor);
                              }

                              // Get all common colors and set to array

                              if(klevu_filterNames.indexOf(baseColor) === -1) {
                                   klevu_filterNames.push(baseColor);
                              }
                              klevu_commonColorMapFormatted.push(baseColorMap);
                              klevu_commonColorMap.push(chaseColorMap);
                          }
                      klevu_commonColorMap = makeUnique(klevu_commonColorMap);
                      klevu_commonColorMapFormatted = makeUnique(klevu_commonColorMapFormatted);
                      klevu_filterNames = klevu_filterNames.length > 0 ? makeUnique(klevu_filterNames) : '';
                      try {
                          if(!klevu_commonColorMap) {
                              throw 'Critcial Error: No Common Color Map Object. Showing Default Color Filters';
                          }
                          else if(!klevu_commonColorMapFormatted) {
                              throw 'Critcial Error: No Common Color Formatted Map Object. Showing Default Color Filters';
                          }
                          else if(!klevu_filterNames) {
                              throw 'Critcial Error: No Common Color Filters Object. Showing Default Color Filters';
                          }   
                      } catch (err) { console.log(err); }
                  }
              } catch (err) { console.log(err); }
                              
          } else{
              setTimeout( klevu_loadLayout, 200 );
          }        
      },  showLandingPageData: function (product) {

  var toReturn = '',
    toAppendwithSalePrice = '',
    priceWithCurrency = '',
    appendCurrencyAtLast = false,
    salepriceClass = 'kuSalePrice',
    priceFormatter, priceToSet,
    showToLabel = false,
    additionalParams = '',
    keywords = document.getElementById('searchedKeyword').value,
    trackingParams = "",
    trackingEventHtml = "",
    i = 0,
    currentSwatch, swatchEventHandlerHtml,
    swatchFocusHandler, swatchBlurHandler, swatchColor,
    swatchCount = 0,
    swatchesShown = false,
    swatchesHtml = "",
    totalSwatchesToShow = 5;

  product = klevu_productCustomizations(product);
  if (product.productImage.trim().length === 0) {
    product.productImage = klevu_userOptions.noImageUrl;
  }

  if (klevu_apiKey === 'klevu-13939350527231') {
    toAppendwithSalePrice = '<span class="priceGreyText">Starting Price</span>';
  }

  if (klevu_userOptions.openProductClicksInNewWindow) {
    additionalParams = ' target="_blank"';
  } else {
    additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
  }
  trackingParams = '{' +
    'data: {' +
    'code: \'' + escape(product.productCode) + '\',' +
    'url: \'' + escape(product.productUrl) + '\',' +
    'name: \'' + escape(product.productName) + '\',' +
    'salePrice: \'' + escape(product.salePrice) + '\',' +
    'rating: \'' + escape(product.rating) + '\',' +
    'position: ' + product.productPosition + ',' +
    'category: \'' + escape(product.category) + '\',' +
    'sku: \'' + escape(product.sku) + '\'' +
    '},' +
    'apiKey: null,' +
    'keywordsLP: \'' + escape(keywords) + '\'' +
    '}';

  if (klevu_commons.isMobileDevice()) {
    trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
  } else {
    trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
  }
  try {
    // code for the result block
    toReturn += '<li>';
    toReturn += '<div class="klevuImgWrap">';
    toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" ';
    if (klevu_userOptions.showRolloverImage && product.imageHover) {
      toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');" ' +
        ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover) + '\', \'klevuProductImage-' + product.id + '\');" ';
    }
    toReturn += ' target="_blank" ' + trackingEventHtml +
      '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' +
      klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/>';

    toReturn += '</a></div>'; //closing image wrap

    if (klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0) {
      totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;
      for (i = 0; i < totalSwatchesToShow; i++) {
        currentSwatch = product.swatches.swatch[i];
        if (currentSwatch.image) {
          swatchesShown = true;
          swatchColor = currentSwatch.color.replace(/ /g, "").replace(/-/g, "");
          if (!currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor)) {
            swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
          } else {
            swatchesHtml += '<div class="klevuSwatchItem">';
          }
          swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
          swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';
          if (klevu_commons.isMobileDevice()) {
            swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
          } else {
            swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler + '" onmouseenter = "' + swatchFocusHandler + '" ';
          }

          swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;
          swatchesHtml += ' style = "background-color:' + swatchColor +
            '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '">';
          swatchesHtml += '</a></div>';
        } else {
          swatchCount += 1;
        }
      }
      if (product.swatches.swatch.length > totalSwatchesToShow) {
        swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
      }
      if (!swatchesShown) {
        swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
      } else {
        swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
      }
      swatchCount += (product.swatches.numberOfAdditionalVariants ? +(product.swatches.numberOfAdditionalVariants) : 0);
      if (swatchCount > 0 && swatchesShown) {
        swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' +
          '<a href = "' + product.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + trackingEventHtml +
          '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
      }

      swatchesHtml += '</div>';
      toReturn += swatchesHtml;
    }
  } catch (e) {}

  if ('undefined' !== typeof klevu_showDiscountBadge &&
    klevu_showDiscountBadge && product.discount != '' &&
    product.discount != '0' && product.discount != '0.0') {
    if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
      toReturn += '<div class="kuDiscountBadge">' +
        klevu_uiLabels.discountBadgeText + ' ' +
        Number(product.discount).toFixed(0) +
        '%</div>';
    } else {
      toReturn += '<div class="kuDiscountBadge">' +
        klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
        '</div>';
    }
  }
  toReturn += '<div class="kuNameDesc">';
  toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g, "%22") +
    '" target="_blank" ' + trackingEventHtml;
  toReturn += product.productName + '</a></div>';
  toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
  if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
    Number(product.rating) <= 5 && Number(product.rating) >= 0) {
    var starWidth = 20 * Number(product.rating);
    toReturn += '<div class="kuStarsSmall">' +
      '<div class="kuRating" style="width:' + starWidth +
      '%;"></div></div>';
  }
  toReturn += '</div>';

  toReturn += '<div class="kuPrice">';
  if (klevu_showPrices) {
    if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
      toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
        salepriceClass, 'kuSalePrice kuSpecialPrice');
    } else {
      toReturn += klevu_commons.showProductPrices('LANDING', product,
        salepriceClass, 'kuSalePrice kuSpecialPrice');
    }
  }
  if ((product.salePrice || product.price) && product.price > product.salePrice) {
    var percentage = ((product.price - product.salePrice) / product.price) * 100;
    percentage = Math.round(percentage);
    toReturn += '<span class="price__percentage">(' + percentage + ' % off)</span>';
  }


  if (klevu_userOptions.vatCaption.trim().length > 0) {
    toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
  }

  if (product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown) {
    if (klevu_uiLabels.variants.indexOf("#") === -1) {
      toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
        ' ' + klevu_uiLabels.variants + '</div>';
    } else {
      toReturn += '<div class="klevu-variants">' +
        klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
    }
  }
  if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
    if ((product.inStock) && product.inStock === 'no') {
      toReturn += '<div class="klevu-out-of-stock">' +
        klevu_userOptions.outOfStockCaption + '</div>';
    }
  }

  toReturn += '</div>';
  if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
    if (!(product.isCustomOptionsAvailable && product.isCustomOptionsAvailable === "yes") &&
      (!product.totalProductVariants || product.totalProductVariants == '0')) {
      toReturn += '<div class="kuAddtocart">' +
        '<input type="text" name="klevu-qty" id="klevu-qty-' +
        escape(product.productCode) + '" placeholder="' +
        klevu_uiLabels.addToCartPlaceholder + '"/>' +
        '<a href="javascript:klevu_lpSendProductToCart(\'' +
        escape(product.productCode) + '\', \'' +
        escape(product.productUrl) + '\', \'klevu-qty-' +
        escape(product.productCode) + '\');" ' +
        'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
        '</div>';
    } else {
      toReturn += '<div class="kuAddtocart">' +
        '<a href="' + product.productUrl.replace(/"/g, "%22") +
        '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
        '</div>';
    }
    toReturn += '<div class="klevu-clearboth-listview"></div>';
  }
  toReturn += '<div class="kuClearLeft"></div>';
  toReturn += '</li>';

  return toReturn;
},

      landingFilters: {
          showFilters: function(filters) {
              var doc = document,
                  filterBox = doc.getElementById( 'kuFilters' ),
                  i, len, j = 0, k = 0,
                  filterBoxIds = new Array(),
                  multiselectClass = '',
                  colorResults,
                  incIndex,
                  colorSelectedNew = [],
                  mapMissing = [],
                  filterByDoc;


              klevuLandingFilterTxt = '';
              filterBox.innerHTML = '';

              

              if( 'undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters ){
                multiselectClass = ' kuMulticheck';
              }
              // if filters are found in the received xml,
              // show the filters based on their type.
              if( filters && filters.length > 0 ){
                  filterBox.className = "kuFilters" + multiselectClass;
                  for( i = 0, len = filters.length; i < len; i++ ){
                      if( filters[i].key === 'Price Range' && !klevu_showPrices ){
                        continue;
                      }
                      // Get Global Colors, Base Colors, and Swatches

                      if (filters[i].key === 'color' && klevu_commonColorMap.length > 0 && klevu_commonColorMapFormatted.length > 0 && klevu_filterNames.length > 0) {
                          if(klevu_userOptions.selectedLandingFilters !== '') {
                              var removeDuplicates = klevu_userOptions.selectedLandingFilters.split(';;');
                                  removeDuplicates = makeUnique(removeDuplicates);
                                  klevu_userOptions.selectedLandingFilters = removeDuplicates.join(';;');
                          }
                          var calcCommon = klevu_userOptions.selectedLandingFilters !== '' ? klevu_userOptions.selectedLandingFilters.split(';;') : '',
                              compCommon = '',
                              mapBase = [],
                              newCount = 0,
                              othersSelected = [];

                          if(calcCommon !== '') {
                              for(var p = 0; p < calcCommon.length; p++) {
                                  var splitCommon = calcCommon[p].split(':');
                                  if(klevu_filterNames.indexOf(splitCommon[1].toLowerCase()) !== -1 && compCommon === '') {
                                  
                                          compCommon = splitCommon[1];
                                      
                                  }
                                  else if ( klevu_filterNames.indexOf(splitCommon[1].toLowerCase()) !== -1 && compCommon !== '' ) {
                                  
                                          othersSelected.push(splitCommon[1]);
                                  }
                                  else if(compCommon !== '') {
                                      for(var u = 0; u < klevu_commonColorMap.length; u++) {
                                          var splitCommonMap = klevu_commonColorMap[u].split(':');
                                          if(splitCommonMap[1] === compCommon) {
                                              if(splitCommon[1] === splitCommonMap[0]) {
                                                  mapBase.push(splitCommon[1]);
                                                  //break;
                                              }
                                              
                                          }
                                      }
                                  }
                              }
                          }   

                          if(mapBase.length > 0) {
                              mapBase = makeUnique(mapBase);
                          }

                          if(othersSelected.length > 0) {
                              othersSelected = makeUnique(othersSelected);
                          }
                          for(var f = 0; f < filters[i]['options'].length; f++) {
                              if(filters[i]['options'][f]['isSelected'] === 'true') {
                                  colorSelectedNew.push(filters[i]['options'][f]['name']);
                                  if(klevu_filterNames.indexOf(filters[i]['options'][f]['name'].toLowerCase()) === -1) {
                                      if(mapBase.length > 0) {
                                          if(mapBase.indexOf(filters[i]['options'][f]['name']) !== -1) {
                                              newCount = newCount + filters[i]['options'][f]['count'];
                                          }
                                      }
                                  }
                              }
                          }
                          try {
                              if(compCommon === '') {
                                  throw 'No color selected';
                              }
                              else {
                                  for(var d = 0; d < klevu_filterNames.length; d++) {
                                      if(compCommon.toLowerCase() === klevu_filterNames[d]) {

                                          // CHECK IF COLOR NAME EXISTS IN DEFAULT RESULTS
                                          if(colorSelectedNew.indexOf(compCommon) === -1) {

                                              var defaultToPush = {};
                                              if(newCount) {
                                                  defaultToPush['count'] = newCount;
                                                  defaultToPush['isSelected'] = 'true';
                                                  mapMissing.push(capitalizeColors(klevu_filterNames[d]));
                                              }
                                              else {
                                                  defaultToPush['count'] = 0;
                                                  defaultToPush['isSelected'] = 'false';
                                              }

                                              defaultToPush['name'] = capitalizeColors(klevu_filterNames[d]);
                                              
                                              defaultToPush['value'] = 'color:' + defaultToPush['name'];
                                              
                                              filters[i]['options'].push(defaultToPush); 
                                          }
                                      }
                                      if(othersSelected.indexOf(capitalizeColors(klevu_filterNames[d])) !== -1) {
                                          if(colorSelectedNew.indexOf(capitalizeColors(klevu_filterNames[d])) === -1) {
                                          
                                               var defaultToPush = {};
                                                  defaultToPush['count'] = 1;
                                                  defaultToPush['isSelected'] = 'true';
                                                  defaultToPush['name'] = capitalizeColors(klevu_filterNames[d]);
                                                  defaultToPush['value'] = 'color:' + defaultToPush['name'];
                                                  filters[i]['options'].push(defaultToPush); 
                                          }
                                      }
                                  }
                                 
                              }
                          } catch (err) { console.log(err); }

                              // Initate Global Common Color Filter Object
                          colorResults = filters[i]['options']; 
                          klevu_commonColors['key'] = 'color';
                          klevu_commonColors['label'] = 'color';
                          klevu_commonColors['type'] = 'other';
                          klevu_commonColors['options'] =  [];
  
                          for(var y = 0; y < colorResults.length; y++) {
                              var filterName = colorResults[y]['name'].replace(/\s+/g, '-').toLowerCase() + ':',
                                  filterCount = colorResults[y]['count'],
                                  filterSelected = colorResults[y]['isSelected'];

                              for(var z = 0; z < klevu_commonColorMapFormatted.length; z++) {

                                  if(klevu_commonColorMapFormatted[z].indexOf(filterName) === 0) {

                                      var commonColor = klevu_commonColorMapFormatted[z].split(':');
                                          commonColor = commonColor[1];

                                      if(klevu_filterNames.indexOf(commonColor) !== -1 && filterCount > 0) {

                                          var valueToPush = {},
                                              compareColors = [];
                                              if(newCount && (capitalizeColors(commonColor) === compCommon)) {
                                                  valueToPush['count'] = filterCount - newCount;
                                              }
                                              else {
                                                  valueToPush['count'] = filterCount;
                                              }
                                              valueToPush['isSelected'] = filterSelected;
                                              valueToPush['name'] = capitalizeColors(commonColor);
                                              valueToPush['value'] = 'color:' + valueToPush['name'];

                                          // If key "options" of Global Common Color Filter Object is Empty, this is the first color. Push it!    

                                          if(isEmpty(klevu_commonColors['options'])) {
                                              klevu_commonColors['options'].push(valueToPush); 
                                          }
                                          else {
                                              for(var l = 0; l < klevu_commonColors['options'].length; l++) {
                                                  compareColors.push(klevu_commonColors['options'][l]['name']);
                                              }
                                              if(compareColors.length > 0 && compareColors.indexOf(valueToPush['name']) === -1) {
                                                  klevu_commonColors['options'].push(valueToPush); 
                                              }
                                              else {
                                                  incIndex = compareColors.indexOf(valueToPush['name']);  
                                                  klevu_commonColors['options'][incIndex]['count'] = klevu_commonColors['options'][incIndex]['count'] + filterCount;
                                              }
                                          }
                                      } 
                                  }
                              }
                          }
                          try {
                              if(!klevu_commonColors) {
                                  throw 'Error Initating Global Common Color Filter Object. Showing Default Color Filters';
                              }
                              else {
                                  filterBoxIds[j] = klevu_landingFilters.displayColorFiltersData(klevu_commonColors);
                              }
                          } catch (err) {
                                  filterBoxIds[j] = klevu_landingFilters.displayFiltersData(filters[i]);
                                  console.log(err);
                          }
                      } 
                      else {
                          filterBoxIds[j] = klevu_landingFilters.displayColorFiltersData(filters[i]);
                      }     
                    j++;
                  }
                  filterBox.innerHTML = klevuLandingFilterTxt;

                  if( 'undefined' !== typeof filterByDoc && filterByDoc ){
                      if( klevuLandingFilterTxt.trim().length === 0 ){
                        filterByDoc.style.display = "none";
                      } else {
                        filterByDoc.style.display = "block";
                      }
                  }

                  for( i = 0, len = filterBoxIds.length; i < len; i++ ){
                      if( filterBoxIds[i] && filterBoxIds[i].trim() != '' ){
                        doc.getElementById( filterBoxIds[i] ).style.height = "auto";
                      }
                  }

                  j = 0;
                  for( k = 0, len = filters.length; k < len; k++ ){
                        var key = filters[k].key.replace( ' ', '_' ),
                          filterOptions = (filters[k].key === 'color' && colorResults.length > 0) ? colorResults : filters[k].options;
                          
                      for( var i = 0; i < filterOptions.length; i++ ){
                          var selected = filterOptions[i].isSelected,
                              kuid = i + key + '~text';
                          if( selected.trim() === 'true' ){
                              if(key === 'color') {
                                  for(var y = 0; y < klevu_commonColors['options'].length; y++) {
                                      if(klevu_commonColors['options'][y].name === filterOptions[i].name) {
                                          if(i > klevu_filterNames.length) {
                                              kuid = y + key + '~text';
                                          }

                                          filterOptions[i].isSelected = 'true';
                                          klevu_commonColors['options'][y].isSelected = 'true';
                                          for(var p = 0; p < klevu_commonColorMap.length; p++) { 
                                              var coveredBases = klevu_commonColorMap[p].split(':'),
                                              referenceColor = coveredBases[1],
                                              trueColor = coveredBases[0];
                                              if(referenceColor === filterOptions[i].name) {
                                                  for(var q = 0; q < filterOptions.length; q++) {
                                                      if(trueColor === filterOptions[q].name) {
                                                          filterOptions[q].isSelected = 'true';
                                                      }
                                                  }
                                              }
                                          }
                                      }
                                  }
                                  klevu_landingFilters.showSelectedFilter( kuid, filterOptions[i].name, j, filters[k].label, key );
                              }
                              else {
                                  klevu_landingFilters.showSelectedFilter( kuid, filterOptions[i].name, j, filters[k].label );
                              }
                            j++;
                          }
                      }
                  }
                  if( 'undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider && klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1 ){
                      klevu_landingFilters.showSelectedFilter( null, klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0], j, null, 'Price-Range' );
                      j++;
                  }
                  if( j === 0 ){
                    klevu_landingFilters.showSelectedFilter( null, null, -1 );
                  }
              
                  //below three lines solve rendering issue for mac browsers like chrome and safari
                  filterBox.style.display = 'none';
                  filterBox.offsetHeight;
                  filterBox.style.display = 'block';
                  if( doc.getElementById('kuFilterRefineMobile') && klevu_commons.isMobileDevice() && ( !klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768 ) ) {
                      klevu_landingFilters.showFiltersOnMobile(!(j===0));
                  } else if(!klevu_commons.isMobileDevice() && screen.width < 769) {
                      klevu_landingFilters.showFiltersOnMobile(!(j===0));
                  }
              } 
              else {
                  filterBox.className = "kuFilters disableKuFilter" + multiselectClass;
              }
          },
          displayColorFiltersData : function( filter ){
              try {
                  if(!filter) {
                      throw 'Error displaying color filters data: No Color Filter Object.'
                  }
                  else {
                      var labelToPut = klevu_translateFilterLabel( filter.label ).toUpperCase(),
                        pricingFilter = false,
                        msrpFilter=false,
                        filterBox = '',
                        filterOptions = filter.options,
                        key = filter.key.replace( ' ', '_' ),label,
                        inStockFilter = false,
                        isAnyOptionSelected = false,
                        truncatedLabel,
                        hoverClass = "kuHover",
                        doc = document;

                        if(klevu_commons.isMobileDevice()){
                          hoverClass = "";
                        }

                        filterBox += '<div class="kuFilterBox '+hoverClass+'" style="height:auto;" id="kuFilterBox-' + key + '">';
                        
                        filterBox += '<div class="kuFilterHead kuCollapse"' +
                                     ' id="kuFilterHead-' + key +
                                     '" onclick="klevu_landingFilters.collapseExpand(' +
                                     ' \'kuFilterHead-' + key + '\', \'kuFilterNames-' + key +
                                     '\', \'kuShowOpt-' + key + '\', \'kuHideOpt-' +
                                     key + '\', \'kuFilterBox-' + key +
                                     '\' );">' + labelToPut + '</div>' +
                                     '<div class="kuFilterNames" id="kuFilterNames-' +
                                     key + '">' + '<ul>';

                      for( var i = 0, len = filterOptions.length; i < len; i++ ){
                          var selected = filterOptions[i].isSelected,
                              kuid = i + key + '~text',
                              kuClass = '',
                              kuCounterClass = 'kuFilterTotal',
                              counterText = filterOptions[i].count,
                              onclickCall = 'klevu_landingFilters.sendColorQuery(\'' + kuid + '\', true );';
                              

                          if( selected.trim() === 'true' ){
                            kuClass = 'kuSelected';
                            kuCounterClass = 'kuFilterCancel';
                            if( 'undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters ){
                              counterText = filterOptions[i].count;
                              isAnyOptionSelected = true;
                            } else{
                              counterText = 'X';
                            }
                            onclickCall = 'klevu_landingFilters.cancelColorFilter(\'' + kuid + '\'); ';
                          }

                          label = filterOptions[i].name;
                          truncatedLabel = label;

                          filterBox += '<li id="' + i + key + '" class="' + kuClass +
                                       '"><a href="javascript:void(0);" onclick="' +
                                       onclickCall + '" title="' + label + '"><span class="kuFilterLabel">' +
                                       truncatedLabel  + '</span><span class="' +
                                       kuCounterClass + '">' + counterText + '</span></a></li>' +
                                       '<input type="hidden" id="' + kuid + '" value="' +
                                       klevu_commons.escapeHtml( filterOptions[i].value ) + '"/>';
                      }
                      filterBox += '</ul></div></div>';

                      klevuLandingFilterTxt += filterBox;
                      if( filterOptions.length > 0 && filterOptions.length < 6 ){
                          return 'kuFilterBox-' + key;
                      }
                  }
              }
              catch (err) {
                  console.log(err);
              }
          },
          sendColorQuery: function( kuid, first ){
              var selectedFilters,
                  doc = document,
                  formattedFilters = '',
                  predefinedFilters = '',
                  filtersBox = doc.getElementById( 'kuFilters' ),
                  checkBoxes,
                  priceFilter = '',
                  primaryFilter,
                  isSelectedV = doc.getElementById( kuid.split( '~' )[0] ),
                  colorName,
                  compareSplit,
                  compareFilters;

              if( first ){
                  try {
                      if(!isSelectedV) {
                          throw 'Error in getting li element of selected filter';
                      }
                      else {
                          isSelectedV.className = 'kuSelected';
                          colorName = isSelectedV.getElementsByTagName('A')[0].title;
                      } 
                  } catch (err) { console.log(err); }
              }
              else {
                  try {
                      if(!isSelectedV) {
                          throw 'Error in getting li element of selected filter';
                      }
                      else {
                          colorName = isSelectedV.getElementsByTagName('A')[0].title;
                      }
                  }  catch (err) { console.log(err); }
              }

              if( 'undefined' !== typeof  klevu_userFilterResults ){
                  predefinedFilters = klevu_userFilterResults;
              }

              checkBoxes = getElementsByClassName( 'kuSelected' , 'li' );

              selectedFilters = '';
              for(var i = 0, len = checkBoxes.length; i < len; i++ ){
                  formattedFilters = klevu_commons.unescapeHtml( doc.getElementById( checkBoxes[i].id +
                                     '~text' ).value );


                  compareFilters = formattedFilters.replace('color:', '').toLowerCase();
                  
                  if(klevu_filterNames.indexOf(compareFilters) !== -1 ) {
                      for(var t = 0; t < klevu_commonColorMap.length; t++) {
                          compareSplit = klevu_commonColorMap[t].split(':');
                          if(compareSplit[1].toLowerCase() === compareFilters) {
                              formattedFilters += ';;color:' + compareSplit[0];
                          }
                      }
                  }

                  if( predefinedFilters.indexOf( formattedFilters ) !== -1 ){ continue; }
                  if( selectedFilters.trim() === ''){
                      selectedFilters += formattedFilters;
                  } else{
                      selectedFilters += ";;"  + formattedFilters;
                  }
              }

              var removeDuplicates = selectedFilters.split(';;');
                  removeDuplicates = makeUnique(removeDuplicates);
                  selectedFilters = removeDuplicates.join(';;');


              try {
                  if(!klevu_commonColorMap) {
                      throw 'Error getting color map object for filters';
                  }
                  else { 
                      if(klevu_commonColorMap.length > 0) {
                         for(var z = 0; z < klevu_commonColorMap.length; z++) {
                              var commonColor = klevu_commonColorMap[z].split(':');
                              if(selectedFilters.indexOf('color:' + commonColor[1]) === 0) {
                                  if(selectedFilters.indexOf('color:' + commonColor[0] + ';;') === -1) {
                                      selectedFilters += ';;' + 'color:' + commonColor[0];
                                  }
                              }
                          } 
                      }
                      else {
                          throw 'No colors exist in color map object';
                      }
                  }
              } catch (err) {
                  console.log(err);
              }
              
              if( 'undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider &&
                  klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1 ){
                priceFilter = ";;" + klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0];
              }
              klevu_userOptions.selectedLandingFilters = selectedFilters + priceFilter;
              if( klevu_addSelectedFiltersToUrl ){
                klevu_commons.addSelectedFiltersToPageUrl( klevu_userOptions.selectedLandingFilters, klevu_productFilterParam );
              }
              klevu_pagination.landingStartPosition = 0;
              if( 'undefined' === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters ){
                doc.body.scrollTop = doc.documentElement.scrollTop = 0;
              }
              //klevu_lpShowLoader();
              if( doc.getElementById("kuProductContent") ){
                doc.getElementById( 'kuProductContent' ).style.opacity = "0.3";
              }
              klevu_landingFilters.loadingFiltersFor = "filter-selection";
              klevu_search.fetchResults( doc.getElementById( 'searchedKeyword' ).value, 'klp' );
              return false;
          },
          showSelectedFilter : function( kuid, selectedFilter, i, filterLabel, filterType ){
              if(klevu_userOptions.selectedLandingFilters) {
                  var filterSplit = klevu_userOptions.selectedLandingFilters.split(';;');
                      filterSplit = makeUnique(filterSplit);
                      klevu_userOptions.selectedLandingFilters = '';
                      klevu_userOptions.selectedLandingFilters = filterSplit.join(';;');
                 

              }
              var doc = document,
                  selectedFilterDoc = doc.getElementById('ku-search-filter-tags'),
                  clearAllEl = doc.getElementById('kuClearAllFilters'),
                  filterHeadText = '',
                  priceFilter = '';
                  if( 'undefined' !== typeof filterType && filterType === 'color') {
                     // console.log('Filters Selected');
                      try {
                          if(!selectedFilter) {
                              throw 'No Filter Selected';
                          }
                          else {
                             
                          }
                      } catch (err) {
                          console.log(err);
                      }

                      try { 
                          if(!klevu_filterNames) { 
                              throw 'Log: Error getting Color Filter Names';
                          }
                          else { 
                              if(klevu_filterNames.length > 0) { 
                                  if(klevu_filterNames.indexOf(selectedFilter.toLowerCase()) === -1) {
                             
                                      try {
                                          if(klevu_userOptions.selectedLandingFilters.indexOf('color:') === -1) {
                                               throw 'Incorrect color filter label';
                                          }
                                          else {
                                              selectedFilter = '';
                                          }
                                      
                                      }  catch (err) { console.log (err); } 
                                 
                                  }   
                          
                              }
                          }
                      } catch (err) {
                          console.log(err);
                      }
                  }
              

              if( selectedFilterDoc ){
                if( i === -1 ){
                  selectedFilterDoc.innerHTML = "";
                  return;
                }
                if( i === 0 ){
                  selectedFilterDoc.innerHTML = "";
                }
                if( filterLabel ){
                  filterHeadText = filterLabel + " : ";
                }      
                if( 'undefined' !== typeof filterType && filterType === 'Price-Range' ) {
                  if( !doc.getElementById('kuPriceRangeTag') ){
                    selectedFilter = selectedFilter.split(':')[1];
                    filterHeadText = klevu_translateFilterLabel( 'PRICE RANGE' ).toUpperCase() + " : ";
                    selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> '+ filterHeadText + selectedFilter +' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); ">x</a></span> ';
                  }
                } 
                else {
                  if( 'undefined' !== typeof filterType && filterType === 'color') {
                      if(selectedFilter !== '' ) {
                          selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag"> '+ filterHeadText + selectedFilter +' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelColorFilter(\'' + kuid + '\',\'' + selectedFilter + '\'); ">x</a></span> ';
                      }
                  }
                  else {
                      selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag"> '+ filterHeadText + selectedFilter +' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelColorFilter(\'' + kuid + '\'); ">x</a></span> ';
                  }
                }
                if( doc.getElementById('kuClearAllFilters') ){
                  doc.getElementById('kuClearAllFilters').parentNode.removeChild( doc.getElementById('kuClearAllFilters') );
                }
                selectedFilterDoc.innerHTML += '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); "><a> ' + klevu_uiLabels.clearAll + '</a></span>';
              }
          },
          clearAllFilters : function(){
              var checkBoxes = getElementsByClassName( 'kuSelected' , 'li' );

              if(klevu_colorSelected.length > 0) {
                  klevu_colorSelected = [];
                  klevu_colorSelectedId = [];
              }
              for(var i = 0, len = checkBoxes.length; i < len; i++ ){
                checkBoxes[i].className = "";
              }
              if( document.getElementById('kuPriceRangeTag') ){
                klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace( /klevu_price:[0-9.\- ]*;*/, '' );
              }
              klevu_landingFilters.sendColorQuery( '', false );
            },

    

          cancelColorFilter : function( id, name ){
         

              var doc = document,
                  refId = id.split('~')[0],
                  appendId = 'text',
                  queryCount,
                  refName = 'Color : ' + name,
                  index;


              if((klevu_colorSelected.length > 0 && klevu_colorSelectedId.length > 0) && (klevu_colorSelected.length == klevu_colorSelectedId.length)) {

                  try {
                      if(klevu_colorSelected.indexOf(refName) === -1) {
                          throw 'Error Removing Color Facet: ' + refName + ' is not in selected array';
                      }
                      else {
                          index = klevu_colorSelected.indexOf(refName);
                                  klevu_colorSelected[index] = undefined;
                                  klevu_colorSelected = klevu_colorSelected.filter(Boolean);
                               
                      }
                  } catch (err) { 
                      console.log(err); 

                  }

                  try {
                      if(klevu_colorSelectedId.indexOf(id) === -1) {
                          throw 'Error Removing Color Facet: ' + id + ' is not in selected array';
                      }
                      else {
                          index = klevu_colorSelectedId.indexOf(id);
                                  klevu_colorSelectedId[index] = undefined;
                                  klevu_colorSelectedId = klevu_colorSelectedId.filter(Boolean);
                                  
                          if(klevu_colorSelected.length > klevu_colorSelectedId.length) {
                              klevu_colorSelected[index] = undefined;
                              klevu_colorSelected = klevu_colorSelected.filter(Boolean);
                       
                          }
                      }
                  } catch (err) {
                      console.log(err);
                      if((klevu_colorSelectedId.length > klevu_colorSelected.length) && klevu_colorSelected.indexOf(refName) !== -1) {
                          index = klevu_colorSelected.indexOf(refName);
                                  klevu_colorSelectedId[index] = undefined;
                                  klevu_colorSelectedId = klevu_colorSelectedId.filter(Boolean);
                     
                      }
                  }
              }
              
              if(!doc.getElementById( refId )) {
                  refId = refId.replace('color', '');
              
                  queryCount = doc.querySelectorAll('#kuFilterNames-color > ul > li').length;
                  if ( refId >= queryCount) {

                      if(doc.querySelector('li.kuSelected > a[title="'+name+'"]')) {
                          var getCorrectId = doc.querySelector('li.kuSelected > a[title="'+name+'"]');
                              getCorrectId = getCorrectId.parentElement.id;
                          if(getCorrectId) {
                              refId = getCorrectId;
                              id = refId + '~' + appendId;
                          }
                      }
                      else {
                          for(var q = 0; q < doc.getElementsByClassName('kuFilterLabel').length; q++) { 
                              if (doc.getElementsByClassName('kuFilterLabel')[q].innerHTML === name) { 
                                  var father = doc.getElementsByClassName('kuFilterLabel')[q].parentElement, 
                                  getCorrectId = father.parentElement.id;  
                            
                              } 
                          }
                          if(getCorrectId) {
                              refId = getCorrectId;
                              id = refId + '~' + appendId;
                          }
                      }
                  }
              }
              else if(doc.querySelector('li.kuSelected > a[title="'+name+'"]')) {
                  var getCorrectId = doc.querySelector('li.kuSelected > a[title="'+name+'"]');
                      getCorrectId = getCorrectId.parentElement.id;
                  if(getCorrectId) {
                      refId = getCorrectId;
                      id = refId + '~' + appendId;
          
                  }
              }

              try { 
                  if(refId >= queryCount) {
                      throw 'Error: refId is out of range';
                  }
                  else {
                      console.log(doc.getElementById( refId ));
                      try { 
                          if(!doc.getElementById( refId ).className) {
                              throw 'Color Swatch li#' + refId + ' does not exist';
                          }
                          else {
                              doc.getElementById( refId ).className = '';
                          }
                      } catch(e) {
                          console.log(e);
                      }
                  }
              } catch(err) {
                  console.log(err);
              }
              klevu_landingFilters.sendColorQuery( id, false );
          },
          showFiltersOnMobile: function (updateRefineByDiv) {
    var doc = document,
        filtersDiv = doc.getElementById('kuFilters'),
        narrowByDiv = doc.getElementById('kuFilterRefineMobile');
    updateRefineByDiv = typeof updateRefineByDiv !== 'undefined' ? updateRefineByDiv : true;
    if( narrowByDiv.className.indexOf( 'kuCollapse' ) !== -1 ){
      if( updateRefineByDiv ){
        narrowByDiv.className = 'kuFilterRefineMobile kuExpand';
        filtersDiv.style.cssText += ";display : none";
      } else{
        filtersDiv.style.cssText += ";display : block";
      }

    } else if( narrowByDiv.className.indexOf( 'kuExpand' ) !== -1 ){
      if( updateRefineByDiv ){
        narrowByDiv.className = 'kuFilterRefineMobile kuCollapse';
        filtersDiv.style.cssText += ";display : block";
      } else {
        filtersDiv.style.cssText += ";display : none";
      }
      var filterBoxes = getElementsByClassName('kuFilterHead', 'div');
      for(var i = 0, len = filterBoxes.length; i < len; i++ ){
        if( filterBoxes[i].className.indexOf( 'kuCollapse' ) !== -1 ){
          filterBoxes[i].click();
        }
      }
    }
  }
      }
}




function klevu_afterLandingResultsLoaded(results) {
// REODER Size facet
var sizeFacetLabelArr = document.querySelectorAll('#kuFilterNames-size ul li a');

var plusSizeFacet = '<ul class="plus-size__facet"></ul>';

document.getElementById('kuFilterNames-size').insertAdjacentHTML('beforeend' , plusSizeFacet);

var newFacet = document.querySelector('.plus-size__facet');

// define the order:
for (var i = 0; i < sizeFacetLabelArr.length; i++) {
  var element = sizeFacetLabelArr[i];
  switch (element.getAttribute("title").toLowerCase()) {
    case "xs":
      element.parentElement.style.order = '0';
      break;
    case "s":
      element.parentElement.style.order = '1';
      break;
    case "m":
      element.parentElement.style.order = '2';
      break;
    case "l":
      element.parentElement.style.order = '3';
      break;
    case "xl":
      element.parentElement.style.order = '4';
      break;
    case "02":
      element.parentElement.style.order = '5';
      break;
    case "04":
      element.parentElement.style.order = '6';
      break;
    case "06":
      element.parentElement.style.order = '7';
      break;
    case "08":
      element.parentElement.style.order = '8';
      break;
    case "10":
      element.parentElement.style.order = '9';
      break;
    case "12":
      element.parentElement.style.order = '10';
      break;
    case "14":
      element.parentElement.style.order = '11';
      break;
    case "16":
      element.parentElement.style.order = '12';
      break;
    case "1x":
      element.parentElement.style.order = '13';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "2x":
      element.parentElement.style.order = '14';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "3x":
      element.parentElement.style.order = '15';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "14w":
      element.parentElement.style.order = '16';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "16w":
      element.parentElement.style.order = '17';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "18w":
      element.parentElement.style.order = '18';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "20w":
      element.parentElement.style.order = '19';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "22w":
      element.parentElement.style.order = '20';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
    case "24w":
      element.parentElement.style.order = '21';
      newFacet.insertAdjacentElement('beforeend' , element.parentElement);
      break;
   

    default:
      element.parentElement.style.order = '50'
      break;
  }
}



/* 

   ------------------------------------------------------------------------
   07.03 - JAMES
   COOL THINGS BELOW - EDIT AT YOUR OWN RISK 
   ------------------------------------------------------------------------

*/

var doc = document,
  htm = doc.documentElement,
  colorFacet = doc.getElementById('kuFilterBox-color') ? doc.getElementById('kuFilterBox-color') : '',
              facetsContainer = doc.getElementById('kuFilters') ? doc.getElementById('kuFilters') : '',
              filterHeads = doc.querySelectorAll('.kuFilterHead') ? doc.querySelectorAll('.kuFilterHead') : '',
              titleTotalFound = doc.createElement('DIV'),
              kuProListing = doc.getElementById('kuProListing') ? doc.getElementById('kuProListing') : '',
              kuSortHeader = doc.querySelector('#kuProductContent > .kuSortHeader') ? doc.querySelector('#kuProductContent > .kuSortHeader') : '',
              kuFilterNames = doc.getElementsByClassName('kuFilterNames') ? doc.getElementsByClassName('kuFilterNames') : '',
              kuSearchFilterTags = doc.getElementById('ku-search-filter-tags') ? doc.getElementById('ku-search-filter-tags') : '',
              kuSortBy = doc.getElementsByClassName("kuSortby") ? doc.getElementsByClassName("kuSortby") : '',
              filterTags = kuSearchFilterTags ? kuSearchFilterTags.getElementsByClassName('ku-search-filter-tag') : '',
              colorsSelect = colorFacet ? colorFacet.querySelectorAll('.kuSelected') : '',
              colorsAll = colorFacet ? colorFacet.querySelectorAll('li > a') : '',
              splitTrek = '',
              newFilter = doc.createElement('span');


    

    if(klevu_commons.isMobileDevice()) {

        klevu_commons.attachEvent(window, 'scroll', displayWindowSize);

        // function displayWindowSize() {
        //     if(kuSortHeader !== '') {
        //         kuSortHeader.style.position = htm.scrollTop > 99 ? 'fixed' : 'initial';
        //         if(kuSortHeader.style.position === 'fixed') {
        //             kuSortHeader.style.zIndex = '9999';
        //             kuSortHeader.style.top = '60px';
        //         }
        //     }
        // }

        //refactor function
        function displayWindowSize() {
          if(kuSortHeader !== '') {
               htm.scrollTop > 99 ? kuSortHeader.classList.add('kuSortHeader_fixed') : kuSortHeader.classList.remove('kuSortHeader_fixed');
          }
      }
    }


    if((klevu_colorSelected.length > 0 && klevu_colorSelectedId.length > 0) && (klevu_colorSelected.length ==  klevu_colorSelectedId.length)) {

          for(var p = 0; p < klevu_colorSelected.length; p++) {

              var splitColorSelected = klevu_colorSelected[p].split(' : '),
                  idSelected = klevu_colorSelectedId[p];

              if(filterTags.length > 0 && colorsSelect.length > 0) {
                  for(var w = 0; w < filterTags.length; w++) {
                      //console.log(filterTags[w].innerText.slice(0, -2));
                      if(filterTags[w].innerText.slice(0, -2) === klevu_colorSelected[p]) {
                          var trek = filterTags[w].innerHTML;
                          try {
                              if(trek.indexOf("cancelColorFilter('") === -1) {
                                  throw 'Error getting inner html of color filter';
                              }
                              else {
                                      splitTrek = trek.split("cancelColorFilter('");
                                      splitTrek = splitTrek[1];
                                      splitTrek = splitTrek.split(',');
                                      splitTrek = splitTrek[0].slice(0,-1);
                                      console.log(splitTrek);
                              }
                          } catch (err) { console.log(err); }
                          if(splitTrek !== idSelected ) {
                              filterTags[w].parentNode.removeChild(filterTags[w]);
                              if(doc.querySelectorAll('a.easyFix-' + splitColorSelected[1]).length > 0) {
                                 for(var q = 0; q < doc.querySelectorAll('a.easyFix-' + splitColorSelected[1]).length; q++) {
                                      doc.querySelectorAll('a.easyFix-' + splitColorSelected[1])[q].parentNode.removeChild(doc.querySelectorAll('a.easyFix-' + splitColorSelected[1][q]));
                                 }
                              }
                              newFilter.className = 'ku-search-filter-tag';
                              newFilter.innerHTML = '';
                              newFilter.innerHTML += klevu_colorSelected[p] + ' <a class="easyFix-' + splitColorSelected[1] + ' ku-search-filter-remove" onclick="klevu_landingFilters.cancelColorFilter(\'' + idSelected + '\',\'' + splitColorSelected[1] + '\'); ">x</a> ';
                              kuSearchFilterTags.insertAdjacentElement('afterbegin', newFilter);
                          }
                      }
                  }
                  if(colorsAll && colorsAll.length > 0) {
                      for(var c = 0; c < colorsAll.length; c++) {
                              console.log(colorsAll[c].title);
                              console.log(splitColorSelected[1]);
                         if(colorsAll[c].title === splitColorSelected[1]) {

                              if(!colorsAll[c].parentElement.className.match(/(?:^|\s)kuSelected(?!\S)/)) {
                                  colorsAll[c].parentElement.className = 'kuSelected';
                                  colorsAll[c].setAttribute('onclick', 'klevu_landingFilters.cancelColorFilter(\'' + colorsAll[c].parentElement.id + '~text' +  '\',\'' + colorsAll[c].title + '\')');
                    
                              } else {
                                  colorsAll[c].setAttribute('onclick', 'klevu_landingFilters.cancelColorFilter(\'' + colorsAll[c].parentElement.id + '~text' +  '\',\'' + colorsAll[c].title + '\')');
                              }
                          } 
                      }
                  } 
              }  
          } 
      }
      if(colorsAll && colorsAll.length > 0) {
          for(var b = 0; b < colorsAll.length; b++) {
              colorsAll[b].addEventListener("click", function(e) {
                  if(this.parentElement.className !== 'kuSelected') {
                      this.parentElement.className = '';
                      if(klevu_colorSelected.length > 0) {
                          var index = klevu_colorSelected.indexOf('Color : ' + this.title);
                          if(index !== -1) {
                              klevu_colorSelected[index] = undefined;
                              klevu_colorSelected = klevu_colorSelected.filter(Boolean);
                          }
                      }
                      if(klevu_colorSelectedId.length > 0) { 
                          var index = klevu_colorSelectedId.indexOf(this.parentElement.id + '~text');
                          if(index !== -1) {
                              klevu_colorSelectedId[index] = undefined;
                              klevu_colorSelectedId = klevu_colorSelectedId.filter(Boolean);
                          }
                      }
                  }
                  else {
                      //this.parentElement.className = 'kuSelected';
                      klevu_colorSelected.push('Color : ' + this.title);
                      klevu_colorSelectedId.push(this.parentElement.id + '~text');
                  }
              });
          }
      }     
      function createSwatchFacet (colorFacetId) {
          if(colorFacetId !== '') {
              var facetId = colorFacetId.id,
                  splitId = colorFacetId.id.split('-'),
                  facetName = splitId[splitId.length -1],
                  facetLinks = colorFacetId.getElementsByTagName('li'),
                  currentFacet,
                  splitValue,
                  swatchColor,
                  greaterWrap;

              // We are getting each color list item  and creating a div to place the color into!
              if(facetName && facetLinks.length > 0) {
                  for(var i = 0; i < facetLinks.length; i++) {
                      var colorSwatch = doc.createElement('div');

                      currentFacet = doc.getElementById(i + facetName + '~text');
                      currentFacetWrap = doc.getElementById(i + facetName);
                      colorSwatch.setAttribute('id', i + facetName + 'Swatch')
                      colorSwatch.className = 'common_colorSwatch';
                      greaterWrap = doc.getElementById('kuFilterNames-' + facetName);

                      if(currentFacet) {
                          if(currentFacet.value.indexOf(facetName) !== -1) {
                              splitValue = currentFacet.value;
                              splitValue = splitValue.split(":");
                              swatchColor = splitValue[1];
                              if(swatchColor) {
                                  if(swatchColor.toLowerCase() === 'multicolor') {
                                      colorSwatch.style.backgroundImage = "url('" + window.product.swatches.multicolor.image +"')";
                                      colorSwatch.style.backgroundSize = 'contain';
                                  }
                                 else if(swatchColor.toLowerCase() === 'no color') {
                                      currentFacetWrap.className = 'common_textSwatch';
                                      if(greaterWrap) {
                                          greaterWrap.style.paddingBottom = '30px';
                                      }

                                  }
                                 else if(!isValidColor(swatchColor)) {
                                      colorSwatch.style.backgroundImage = "url('https://js.klevu.com/klevu-js-v1/img-1-1/default-swatch.jpg')";
                                      colorSwatch.style.backgroundSize = 'contain';
                                  }
                                  else {
                                      colorSwatch.style.backgroundColor = swatchColor;
                                  }
                                  // And now we append our new swatches into the DOM and we are done
                                  if(!doc.getElementById( i + facetName + 'Swatch')) {
                                      currentFacet.appendChild(colorSwatch);
                                      if(colorSwatch) {
                                          currentFacetWrap.insertAdjacentElement('afterbegin', colorSwatch);
                                          currentFacetWrap.style.position = 'relative';
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }
      }
      try { 
          if(!klevu_filterNames) { 
              throw 'Error getting Color Filter Names';
          }
          else { 
              createSwatchFacet(colorFacet);
          }
      } catch (err) {
          console.log(err);
      }

if (document.documentElement.clientWidth < 768) {
  var queryString = '';
  
  document.querySelectorAll('.kuFilterNames ul li a').forEach(function (item) {
      disabled = true;
    item.onclick = function (event) {
      event.preventDefault();
      var closestLI = event.target.closest('li');
      closestLI.classList.toggle('kuSelected');
      queryString += item.getAttribute('onclick');
      document.getElementById('applayFilter').setAttribute('onclick', queryString);
    }

  });

}

if (document.documentElement.clientWidth < 768 || klevu_commons.isMobileDevice()) {
              
  var filterBox = document.getElementById( 'kuFilters' );
  var mobFilterButton = '<button class="mobile-filter__button">filter</button>';
  var mobFilterHeading = '<div class="mobile-filter__heding">FILTERS <span class="mobile-filter__close">×</span></div>';
  var applayFilterButton = '<button id="applayFilter">APPLY FILTERS</button>';
  
  if(!document.getElementById('applayFilter')){
    setTimeout(function() {
        document.getElementById( 'kuFilters' ).insertAdjacentHTML('beforeend', applayFilterButton);
            document.getElementById('applayFilter').addEventListener('click', function(e){
        filterBox.classList.remove('mob-filter_opened');
        filterBox.style.display = 'none';
    })
    }, 0);
  }
  
  if(!document.querySelector('.mobile-filter__button')){
    document.querySelector('.kuSortingOpt').insertAdjacentHTML('afterbegin', mobFilterButton);
  }
  
  document.querySelector('.mobile-filter__button').addEventListener('click' , function(){

    filterBox.classList.add('mob-filter_opened');
    filterBox.style.display = 'block';
   
    
  });
  
   if(!document.querySelector('.mobile-filter__close')) {
        filterBox.insertAdjacentHTML('afterbegin', mobFilterHeading);
    }
    
    document.querySelector('.mobile-filter__close').addEventListener('click' , function(){
        filterBox.classList.remove('mob-filter_opened');
        filterBox.style.display = 'none';
    });
    


}

  // collapse all filters
  var selectedFacets = document.querySelectorAll(
    "#ku-search-filter-tags .ku-search-filter-tag"
  );
  var allFacets = document.querySelectorAll("#kuFilters .kuFilterHead");
  
   if (!klevu_commons.isMobileDevice()) {
     
  allFacets.forEach(function(facet) {
    facet.click();
  });


       if (selectedFacets) {
    selectedFacets.forEach(function(element) {
      allFacets.forEach(function(facet) {
        var selectedElement = element.innerText
          .split(":")[0]
          .trim()
          .toUpperCase();
        var allfacetsElement = facet.innerText
          .split(":")[0]
          .trim()
          .toUpperCase();
        if (
          selectedElement === allfacetsElement &&
          !facet.classList.contains("kuCollapse")
        ) {
          facet.click();
        } else {
        }
      });
    });
  }
   }


// selected facets in facet div
  var facetHeader = document.createElement("div");
  facetHeader.classList.add("facetHeader");
  var facetHeaderTopDiv =
    '<div class="facetHeader_top"><span>Filters ('+ klevu_pagination.totalLandingResultsFound +' Results)</span><button onclick="klevu_landingFilters.clearAllFilters(); ">Clear All</button></div>';
  facetHeader.insertAdjacentHTML("afterbegin", facetHeaderTopDiv);
  var facetHeaderBottomDiv = document.createElement("div");
  facetHeaderBottomDiv.classList.add("facetHeader_bottom");
  facetHeaderBottomDiv.innerHTML =
    '<span class="nofilter">No filters applied</span>';
  selectedFacets.forEach(function(selectedFacet) {
    selectedFacet.innerHTML = selectedFacet.innerHTML.replace(' STYLE :', '');
    selectedFacet.innerHTML = selectedFacet.innerHTML.replace(' COLOR :', '');
    selectedFacet.innerHTML = selectedFacet.innerHTML.replace(' Price Range : ', '');

    if (
      facetHeaderBottomDiv.innerHTML ===
      '<span class="nofilter">No filters applied</span>'
    ) {
      facetHeaderBottomDiv.innerHTML = "";
    }
    facetHeaderBottomDiv.insertAdjacentElement("beforeend", selectedFacet);
  });

  facetHeader.insertAdjacentElement("beforeend", facetHeaderBottomDiv);
  
  if (document.documentElement.clientWidth < 768 || klevu_commons.isMobileDevice()) {
    document.querySelector(".mobile-filter__heding").insertAdjacentElement("afterEnd", facetHeader);
  } else {
    document.getElementById("kuFilters").insertAdjacentElement("afterbegin", facetHeader);
  }
  
  document.getElementById('kuFilterHead-Price_Range').innerText = 'PRICE';

if(!document.getElementById('sort-by')) {
  document.getElementById('kuSortby').insertAdjacentHTML('afterbegin', '<option value="Sort By" id="sort-by">Sort By</option>');
  document.getElementById('kuSortby').selectedIndex = '0';
}


}

function klevu_uc_productCustomizations(product) {

      var customSwatches = product.swatches.swatch ? product.swatches.swatch : '',
          swatchNameOverride = '';

  
      function mapSwatchImages(swatches) {
          for(var i = 0; i < customSwatches.length; i++) {
              var colorFormatted = customSwatches[i].color.replace(/\s+/g, '-').toLowerCase();
              for(var j = 0; j < swatches.length; j++) {

                  if(colorFormatted === swatches[j][0]) {
                      if(swatches[j][1].image !== null) {
                          customSwatches[i].swatchImage = swatches[j][1].image;
                      }
                      else {
                          if(isValidColor(swatches[j][0])) {
                              customSwatches[i].color = swatches[j][0].charAt(0).toUpperCase() + swatches[j][0].slice(1);
                          }
                          else {
                              customSwatches[i].color = swatches[j][1].color;
                              swatchNameOverride += swatches[j][1].color + ':' + swatches[j][0] + ';';
                          }
                      }
                      break;

                  }
                  if (j == swatches.length - 1) {
                      for(var m = 0; m < swatches.length; m++) {
                          var colorSplit = swatches[m][0].split('-');
                          for ( var u = 0; u < colorSplit.length; u++) {
                              if(colorFormatted.indexOf(colorSplit[u]) !== -1) {
                                  if(swatches[m][1].image !== null) {
                                      customSwatches[i].swatchImage = swatches[m][1].image;
                                  }
                                  else {
                                      if(isValidColor(swatches[m][0])) {
                                          customSwatches[i].color = swatches[m][0].charAt(0).toUpperCase() + swatches[m][0].slice(1);
                                      }
                                      else {
                                          customSwatches[i].color = swatches[m][1].color;
                                          swatchNameOverride += swatches[m][1].color + ':' + swatches[m][0] + ';';
                                      }
                                  }
                                  break;
                              }
                          }
                      }
                  }
              }
          }
          if(swatchNameOverride !== '') {
              product.swatchNameOverride = swatchNameOverride;
          }
      }
      if(customSwatches !== '') {
          mapSwatchImages(klevu_productSwatches);
      }

      return product;
}



// Global Assistance function to check if the CSS color is valid.
function isValidColor(color) {
if (color === "" || color === "inherit" || color === "transparent") {
  return false;
}
var image = document.createElement("img");
image.style.color = "rgb(0, 0, 0)";
image.style.color = color;
if (image.style.color !== "rgb(0, 0, 0)") {
  return true;
}
image.style.color = "rgb(255, 255, 255)";
image.style.color = color;
return image.style.color !== "rgb(255, 255, 255)";

}

  function makeUnique(arr){
      var uniqueArray=[];
      arr.forEach(function(element){
         if(uniqueArray.indexOf(element)===-1){
             uniqueArray.push(element);
         }
     });
     return uniqueArray;
  }

  function isEmpty(obj) {
      return Object.keys(obj).length === 0;
  }

  function capitalizeColors(str) {
      str = str.split(' ');
      if(str.length > 0) {
          var refThis = '';
          for(var b = 0; b < str.length; b++) {
              refThis += str[b].charAt(0).toUpperCase() + str[b].slice(1) + ' ';
          }
          return refThis.slice(0, -1);
      } 
  }
